import { render, staticRenderFns } from "./AK5Icon.vue?vue&type=template&id=04f3af59&scoped=true&"
import script from "./AK5Icon.vue?vue&type=script&lang=js&"
export * from "./AK5Icon.vue?vue&type=script&lang=js&"
import style0 from "./AK5Icon.vue?vue&type=style&index=0&id=04f3af59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f3af59",
  null
  
)

export default component.exports